import * as ActionTypes from './types';
import { actionCreator } from '../helpers/actionCreator';

export const checkConnectivity = actionCreator(ActionTypes.CHECK_CONNECTIVITY);
export const checkConnectivitySuccess = actionCreator(ActionTypes.CHECK_CONNECTIVITY_SUCCESS);
export const checkConnectivityFailed = actionCreator(ActionTypes.CHECK_CONNECTIVITY_FAILED);
